module.exports = __webpack_public_path__ + "static/media/CDC-Mentions1-FR.9b460bcf.jpg";